import React from "react";
import "./StandardText.css";

const StandardText = ({ title, htmlContent, background }) => {
  return (
    <section
      className="standard-text"
      style={{ backgroundImage: background ? `url(${background})` : "none" }}
    >
      <div className="standard-content">
        {title && <h2 className="standard-title">{title}</h2>}
        {htmlContent && (
          <div
            className="standard-html-content"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
        )}
      </div>
    </section>
  );
};

export default StandardText;
